import React from 'react'
import { MaterialReactTable } from 'material-react-table'
import { MRT_Localization_ES as MRTLocalizationES } from 'material-react-table/locales/es'
import { Button, Typography } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'

/**
 * Tabla de leads (material-react-table) con estado TOTALMENTE controlado desde el contenedor.
 *
 * La version anterior usaba material-table con data remota; de ahi venian los 3 bugs:
 *  - la seleccion vivia dentro de la data que la libreria guardaba, por lo que cualquier
 *    refetch (cambiar de pagina) la borraba,
 *  - su pageIndex interno se desincronizaba del `page` que devuelve el backend, y la
 *    ultima pagina quedaba en blanco,
 *  - pageSize grande no se respetaba porque la libreria re-paginaba en cliente.
 *
 * Aqui NADA es estado interno: paginacion, busqueda y seleccion son props. La seleccion se
 * indexa por id (getRowId), asi que sobrevive el cambio de pagina y admite ids de paginas
 * que ya no estan cargadas ("seleccionar todos los filtrados").
 */
const TableType3 = (props) => {
  const {
    columns,
    data = [],
    rowCount = 0,
    isLoading = false,
    pagination,
    onPaginationChange,
    globalFilter = '',
    onGlobalFilterChange,
    rowSelection = {},
    onRowSelectionChange,
    isSelection = true,
    hiddenIntegration = false,
    onIntegrate,
    totalSelected = 0,
  } = props

  /** una fila ya integrada o repetida no se puede volver a integrar */
  const isRowSelectable = (row) =>
    row.original.integrado_impulsa !== '1' &&
    row.original.nombre_establecimiento !== 'LEAD REPETIDO'

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      localization={MRTLocalizationES}
      // ---- id estable: es la llave de la seleccion cross-page ----
      getRowId={(row) => String(row.id)}
      // ---- todo server-side: la tabla no re-pagina ni re-filtra en cliente ----
      manualPagination
      manualFiltering
      enableSorting={false}
      rowCount={rowCount}
      enableGlobalFilterModes={false}
      enableColumnFilters={false}
      enableHiding={false}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableStickyHeader
      enablePinning
      enableRowSelection={isSelection ? isRowSelectable : false}
      selectAllMode="page"
      muiSelectCheckboxProps={{ color: 'primary' }}
      muiSelectAllCheckboxProps={{ color: 'primary' }}
      // el aviso de seleccion lo pinta LeadPage (necesita el total cross-page, no el de la pagina)
      positionToolbarAlertBanner="none"
      state={{
        isLoading,
        pagination,
        globalFilter,
        rowSelection,
        showProgressBars: isLoading,
      }}
      onPaginationChange={onPaginationChange}
      onGlobalFilterChange={onGlobalFilterChange}
      onRowSelectionChange={onRowSelectionChange}
      initialState={{
        density: 'compact',
        showGlobalFilter: true,
        columnPinning: { left: ['mrt-row-select', 'actions'] },
      }}
      muiSearchTextFieldProps={{
        placeholder: 'Buscar (nombre, documento, correo, teléfono, vehículo)',
        sx: { minWidth: 320 },
        variant: 'outlined',
        size: 'small',
      }}
      muiPaginationProps={{
        rowsPerPageOptions: [10, 25, 50, 100],
        showFirstButton: true,
        showLastButton: true,
      }}
      // altura acotada + sticky header: con pageSize 100 se recorren las 100 filas dentro
      // de la tabla, sin que el scroll de la pagina "esconda" el resto
      muiTableContainerProps={{ sx: { maxHeight: 'calc(100vh - 300px)' } }}
      muiTablePaperProps={{
        sx: { boxShadow: 'none', border: '1px solid #e5e7eb', borderRadius: 2 },
      }}
      muiTableHeadCellProps={{
        sx: { backgroundColor: '#fff', color: '#000', fontWeight: 700 },
      }}
      muiTableBodyCellProps={{ sx: { fontSize: 14 } }}
      renderTopToolbarCustomActions={() => (
        <div
          style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: 16 }}>LEADS</Typography>
          {!hiddenIntegration && (
            <Button
              variant="contained"
              color="success"
              size="small"
              disableElevation
              startIcon={<RefreshIcon />}
              disabled={totalSelected === 0}
              onClick={() => onIntegrate()}
            >
              {totalSelected > 0 ? `Reintegrar (${totalSelected})` : 'Reintegrar'}
            </Button>
          )}
        </div>
      )}
    />
  )
}

export default TableType3
